import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'

import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'

import KNSignature from 'components/KNSignature/KNSignature'
import { getFieldErrorMessages } from 'global/helpers/form'
import type { KNFormSignatureProps } from './types'

const KNFormSignature = <T extends FieldValues>({
  name,
  control,
  rules,
  label,
  size,
  sx,
  disabled,
}: KNFormSignatureProps<T>): ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value, name, ref }, fieldState: { invalid, error }, formState }): ReactElement => (
      <FormControl fullWidth sx={sx} error={invalid} disabled={formState.isSubmitting || disabled}>
        {label && <FormLabel sx={{ marginBottom: 1 }}>{label}</FormLabel>}
        <KNSignature onChange={(output) => onChange(output)} />
        {error?.message && <FormHelperText>{getFieldErrorMessages(error)}</FormHelperText>}
      </FormControl>
    )}
  />
)

export default KNFormSignature
